// Datetime component
import React from "react"
import "twin.macro"
import { DateTime } from "luxon"

const TTL_QUESTION_DAYS = 90

export const getExpDays = (createAt: string) => {
  return Math.ceil(DateTime.fromISO(createAt).plus({ days: TTL_QUESTION_DAYS }).diff(DateTime.local(), "days").days)
}

export enum DateTimeLayout {
  Question = "question",
}
export interface DatetimeProps {
  datetime: DateTime
}

export const DateTimeFormatter = ({ datetime }: DatetimeProps) => {
  // Formatting dates and times with Luxon
  // See: https://github.com/moment/luxon/blob/master/docs/formatting.md#table-of-tokens

  // get the localized start datetime
  const startDatetimeLocal = DateTime.fromISO(datetime.toString()).toLocal()
  // Get start date as an ISO DateTimeFormat
  const dateISO = startDatetimeLocal.toISO()

  // Question: Jan 1, 2022
  const startDate = `${startDatetimeLocal.toFormat("LLLL d")}, ${startDatetimeLocal.toFormat("yyyy")}`

  // Get startTime (e.g. 8:30 a.m. EST)
  // Format the AM / PM in datetime to `a.m.` and `p.m.`
  // datetime.toFormat("a") returns the meridiem
  const startTime =
    startDatetimeLocal.toFormat("a") === "AM"
      ? startDatetimeLocal.toFormat("t").replace("AM", "a.m.")
      : startDatetimeLocal.toFormat("t").replace("PM", "p.m.")

  // Get the Timezone
  const zone = startDatetimeLocal.toFormat("ZZZZ")
  return { dateISO, startDate, startTime, zone }
}

export default function Datetime({ datetime }: DatetimeProps) {
  const formatted = DateTimeFormatter({ datetime })

  return (
    <time dateTime={formatted.dateISO} data-chromatic="ignore">
      <span tw="whitespace-nowrap desktop:inline">{formatted.startDate}</span>
    </time>
  )
}
